import { ColorsEnum } from '../mozgoteka'

enum ResultColor {
  Black = ColorsEnum.Black,
  Blue = ColorsEnum.Blue,
  BlueRevert = 'blue-revert',
  Yellow = ColorsEnum.Yellow,
  Green = ColorsEnum.Green,
  Pink = ColorsEnum.Pink,
}

export default ResultColor
